import React, {
    useState,
    useEffect,
} from "react"

import {
    Button,
    Typography,
    Stack,
    Dialog,
    TextField,
    Box,
    Chip,
    Tooltip,
    Paper,
    createTheme,
    ThemeProvider,
    DialogContent,
} from "@mui/material";
import { Help_suggestionBoard } from "../Dialogs/Help/Help_Suggestion";
import ToggleSet from "../Components/ToggleSet";
import { InputName, } from "../Components/Inputs/Input_Name";
import { API_Suggestion } from "../App/api";
import { deleteOptions, empty_uuid, ftchPlus, getOptions, postOptions, putOptions } from "../App/Account_urls";
import { ErrorBar } from "../Components/ErrorBar";
import { faComment as faCommentSolid, faCommentDots as faCommentDotsSolid, faLightbulb as faLightbulbSolid, faThumbsUp as faThumbsUpSolid, faBan, faCheck, faSpinner, faScissors, faBullhorn, faTag, faScroll, faEdit, } from "@fortawesome/free-solid-svg-icons";
import { faComment, faCommentDots, faLightbulb, faThumbsUp, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, { timelineOppositeContentClasses, } from '@mui/lab/TimelineOppositeContent';
import { InputSelect1 } from "../Components/Inputs/Select";
import { InputSearch } from "../Components/Inputs/Input_Search";
import dayjs from "dayjs";
import { useAuth } from "../App/useAuth";
import DOMPurify from "dompurify";
import CloseIcon from "../Components/CloseIcon";





const defIdea = {
    Title: "",
    Comment: "",
}

const urlL = (board) => {
    let url = API_Suggestion + "/" + board
    return url
}
const urlC = (board, id, fn) => {
    let url = urlL(board) + "/" + id
    if (fn !== "") {
        url += "/" + fn
    }
    return url
}

const replaceWithBr = (c) => {
    let x = c.replace(/\n/g, "<br />")
    x = x.replace(/ \* /g, " &#x2022; ")
    return x
}


const SuggestionNew = ({ board, open, name, onClose, ideaId = empty_uuid, title, comment, extraText = "" }) => {
    const [form, setForm] = useState({ Title: "", Comment: "" })
    const [errmsg, setErrmsg] = useState("")

    const onChange_t = (e) => {
        let nf = {
            ...form,
            [e.target.name]: e.target.value,
        };
        setForm(nf);
    };


    const putRequest = async () => {
        setErrmsg("")
        // console.log(form)
        var url = urlL(board)
        var req = postOptions
        if (ideaId !== empty_uuid) {
            req = putOptions;
            url += "/" + ideaId
        }
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                onClose();
            })
            .catch((error) => {
                setErrmsg(error.message)
                // console.log(error);
            });
    };

    const validate = () => {
        let err = ""
        if (form.Title.length < 10) {
            err = "Title is too short (10 characters)"
        } else if (form.Title.split(" ").length < 2) {
            err = "Title is too short (2 words)"
        } else if (form.Comment.length < 30) {
            err = "Description is too short (30 characters)"
        } else if (form.Comment.split(" ").length < 5) {
            err = "Description is too short (5 words)"
        }
        setErrmsg(err)
        // console.log(err)
        return err
    }

    const onSubmit = () => {
        if (validate() === "") {
            putRequest()
        }
    }

    useEffect(() => {
        if (open) {
            setErrmsg("")
            if (ideaId === empty_uuid) {
                setForm(defIdea)
            } else {
                setForm({ Title: title, Comment: comment })

            }
        }
    }, [open])

    const myClose = (event, reason) => {
        if (reason !== 'escapeKeyDown') {
            onClose()
        }
    }

    return (
        <>
            {open && (
                <Dialog
                    sx={{
                        overflow: "scroll",
                        "& .MuiDialog-container": {
                            display: "inline-flex !important",
                            // justifyContent: "flex-start",
                            alignItems: "flex-start",
                            overflow: "scroll",
                            px: 20,
                            py: 20,
                            mx: 30,
                            // width: "100%",
                        },
                    }}
                    maxWidth="100%"
                    open={open}
                    onClose={myClose}
                >
                    <Stack sx={{ mx: 4, my: 4 }} spacing={4}>

                        <Typography variant="h6" gutterBottom>
                            {name}
                        </Typography>
                        <Stack direction="row" spacing={2} >
                            <Button variant="contained" color="secondary" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={onSubmit}                               >
                                Submit
                            </Button>
                        </Stack>
                        <Stack sx={{ mx: 4, my: 4 }} spacing={2}>
                            <Stack spacing={2} >
                                <InputName
                                    label="Title"
                                    name="Title"
                                    maxLength={128}
                                    value={form.Title}
                                    required={true}
                                    sx={{ width: 800 }}
                                    onChange={onChange_t}
                                />
                                <TextField
                                    label="Add a detailed description"
                                    style={{ width: 800 }}
                                    type="text"
                                    multiline
                                    size="small"
                                    rows={10}
                                    required={true}
                                    value={form.Comment}
                                    name="Comment"
                                    onChange={onChange_t}
                                />
                            </Stack>
                        </Stack>
                        <Typography variant="body" gutterBottom>
                            Please Note: New items will be validated and classified before they show up on the board.<br />
                            <span
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(extraText) }}
                            />
                        </Typography>
                    </Stack>
                    <ErrorBar error={errmsg} />
                </Dialog>
            )}
        </>
    )

}




const AddComment = ({ board, idea, open, onCommented, onClose, commentId = empty_uuid, comment }) => {
    const [errmsg, setErrmsg] = useState("")

    let defComment = {
        Comment: ""
    }
    const [form, setForm] = useState({})

    const onChange_t = (e) => {
        let nf = {
            ...form,
            [e.target.name]: e.target.value,
        };
        setForm(nf);
    };

    const putRequest = async () => {
        setErrmsg("")
        var req = postOptions;
        var url = urlC(board, idea.Idea, "comment")
        if (commentId !== empty_uuid) {
            url += "/" + commentId
            req = putOptions
        }
        // console.log(form)
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                onCommented()
                onClose();
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    };

    const validate = () => {
        let err = ""
        if (form.Comment.length < 30) {
            err = "Comment is too short (30 characters)"
        } else if (form.Comment.split(" ").length < 5) {
            err = "Comment is too short (5 words)"
        }
        setErrmsg(err)
        return err
    }

    const onSubmit = () => {
        if (validate() === "") {
            putRequest()
        }
    }

    useEffect(() => {
        setErrmsg("")
        if (open) {
            // console.log(commentId)
            // console.log(comment)
            setForm(commentId === empty_uuid ? defComment : { Comment: comment })
        }
    }, [open])

    const myClose = (event, reason) => {
        if (reason !== 'escapeKeyDown') {
            onClose()
        }
    }

    return (
        <>
            {open && (
                <Dialog
                    maxWidth="100%"
                    open={open}
                    onClose={myClose}
                >
                    <Stack sx={{ mx: 4, my: 4 }} spacing={4}>
                        <Stack direction="row" spacing={2} >
                            <Button variant="contained" color="secondary" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={onSubmit}                               >
                                Submit
                            </Button>
                        </Stack>
                        <Typography variant="h6" align="left" gutterBottom>
                            {idea.Title}
                        </Typography>
                        <TextField
                            label="Add a comment"
                            style={{ width: 800 }}
                            type="text"
                            multiline
                            size="small"
                            rows={10}
                            required={true}
                            value={form.Comment}
                            name="Comment"
                            onChange={onChange_t}
                        />
                    </Stack>
                    <ErrorBar error={errmsg} />
                </Dialog>
            )
            }
        </>
    )
}


const AddTag = ({ board, idea, open, onTagged, onClose, tag = "", avail, comment }) => {
    const [errmsg, setErrmsg] = useState("")
    let defTag = {
        Tag: "",
        SelectTag: "",
        TextTag: ""
    }
    const [form, setForm] = useState(defTag)
    const onChange_any = (name, value, other) => {

        let nf = {
            ...form,
            [name]: value,
            Tag: value,
            [other]: "",
        };
        setForm(nf);
        validate(nf)
    };
    const onChange_t = (e) => {
        onChange_any(e.target.name, e.target.value, "SelectTag")
    };
    const onChange_s = (e) => {
        onChange_any(e.target.name, e.target.value, "TextTag")

    };

    const validate = (nf) => {
        let nt = nf.Tag.trim()
        let spl = nt.split(" ")
        // console.log(spl)
        let err = ""
        if (spl.length !== 1) {
            err = "Tag must contain 1 word"
        } else {
            if (spl[0] === "") {
                err = "Tag must contain 1 word"
            } else {
                let tc = nt.split(":")
                let regExp = /^#[0-9A-F]{6}$/i
                if (tc.length === 2) {
                    if (!regExp.test(tc[1])) {
                        err = "Tag format is Tag:#acbdef"
                    }
                } else if (tc.length > 2) {
                    err = "Tag format is Tag:#acbdef"
                }
            }
        }
        setErrmsg(err)
        return err
    }

    const postRequest = async () => {
        setErrmsg("")
        var req = postOptions;
        var url = urlC(board, idea.Idea, "tag")
        // console.log(form)
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                onTagged()
                setForm(defTag)
                onClose();
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    };

    const deleteRequest = async () => {
        setErrmsg("")
        var req = deleteOptions;
        var url = urlC(board, idea.Idea, "tag")
        // console.log(form)
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                onTagged()
                setForm(defTag)
                onClose();
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    };


    const onSubmit = () => {
        if (validate(form) === "") {
            postRequest()
        }
    }
    const onRemove = () => {
        deleteRequest()
    }

    useEffect(() => {
        setErrmsg("")
        if (open) {
            setForm(tag === "" ? defTag : { Tag: tag, SelectTag: tag, TextTag: "" })
        }
    }, [open])

    const myClose = (event, reason) => {
        if (reason !== 'escapeKeyDown') {
            onClose()
        }
    }

    return (
        <>
            {open && (
                <Dialog
                    maxWidth="100%"
                    open={open}
                    onClose={myClose}
                >
                    <Stack sx={{ mx: 4, my: 4 }} spacing={4}>
                        <Stack direction="row" spacing={2} >
                            <Button variant="contained" color="secondary" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={onSubmit}                               >
                                Submit
                            </Button>

                        </Stack>

                        <Typography variant="h6" align="left" gutterBottom>
                            {idea.Title}
                        </Typography>
                        <Box>
                            <Stack direction="row" spacing={2} >
                                <Box sx={{ pt: 2 }}>
                                    <FontAwesomeIcon
                                        icon={faScissors}
                                        color='black'
                                        size="sm"
                                        onClick={onRemove}
                                    />
                                </Box>
                                <InputSelect1
                                    label="Tag"
                                    name="SelectTag"
                                    onChange={onChange_s}
                                    value={form.SelectTag}
                                    minWidth={140}
                                    maxWidth={140}
                                    avail={avail}
                                />
                                <TextField
                                    label="Add a new tag"
                                    style={{ width: 200 }}
                                    type="text"
                                    size="small"
                                    slotProps={{
                                        htmlInput: {
                                            maxLength: 20,
                                        },
                                    }}
                                    required={true}
                                    value={form.TextTag}
                                    name="TextTag"
                                    onChange={onChange_t}
                                />


                            </Stack>
                        </Box>
                    </Stack>
                    <ErrorBar error={errmsg} />
                </Dialog >
            )
            }
        </>
    )
}


let iconColor = "black"

const TimelineComment = ({ board, idea, c, onRemove, onChange }) => {
    const { admin_r } = useAuth();
    const [admin, setAdmin] = useState(admin_r.current)
    const [openComment, setOpenComment] = useState(false)


    const onEdit = () => {
        setOpenComment(true)
    }




    return (
        <>
            <TimelineItem>
                <TimelineOppositeContent
                    // sx={{ m: 'auto 0' }}
                    sx={{
                        mt: 1,
                        minWidth: 200
                    }}
                    align="right"
                    variant="body2"
                    color="text.secondary"
                >
                    <Typography variant="body2" gutterBottom>
                        {c.Author}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        {dayjs(c.Date).format("D-MMM-YYYY H:mm")}
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot variant={c.Mine ? "filled" : "outlined"} color={c.Status !== "" ? colorStatus(c.Status) : "primary"} />
                    <TimelineConnector />
                </TimelineSeparator>


                <TimelineContent >

                    <Box sx={{ ml: 1.5, mt: 1.5, pr: 1.5 }}>
                        <Stack direction="row" spacing={2}>
                            <Stack direction="row" spacing={2}>
                                {(admin || (c.Mine && c.Status === "")) && (
                                    <FontAwesomeIcon
                                        icon={faScissors}
                                        color='black'
                                        size="sm"
                                        onClick={onRemove}
                                    />
                                )}
                                {(c.Mine && c.Status === "") && (
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        color='blue'
                                        size="sm"
                                        onClick={onEdit}
                                    />
                                )}
                            </Stack>

                            {c.Status === "" && (
                                <Box>
                                    <Stack sx={{ mt: -1.5 }} direction="row" spacing={2}>
                                        <Paper elevation={2}>
                                            <Typography sx={{ m: 2, minWidth: 600, maxWidth: 1600 }}
                                                variant="body2"
                                            >
                                                <span
                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(replaceWithBr(c.Comment)) }}
                                                />
                                            </Typography>
                                        </Paper>
                                    </Stack>
                                </Box>
                            )}
                            {c.Status !== "" && (
                                <Box>
                                    <Chip sx={{ mt: -3 }}
                                        label={c.Status}
                                        variant="contained"
                                        color={colorStatus(c.Status)}
                                        size="small"
                                    />
                                </Box>
                            )}
                        </Stack>
                    </Box>

                </TimelineContent>
                {/* {c.Status === "" && (
                    <TimelineContent
                        minWidth={1000}
                        maxWidth={1600}
                    >

                    </TimelineContent>
                )}
                {c.Status !== "" && (

                    <TimelineContent
                        minWidth={1000}
                        maxWidth={1600}
                    >
                        <Chip
                            label={c.Status}
                            variant="contained"
                            color={colorStatus(c.Status)}
                            size="small"
                        />

                    </TimelineContent>
                )} */}
            </TimelineItem >
            <AddComment open={openComment} board={board} idea={idea}
                commentId={c.Uuid}
                comment={c.Comment}
                onClose={() => setOpenComment(false)}
                onCommented={onChange} />
        </>
    )
}


const Suggestion = ({ name, open, board, idea, form, onClose, onLike, onChange, avail }) => {
    const { admin_r } = useAuth();
    const [admin] = useState(admin_r.current)

    const [newOpen, setNewOpen] = useState(false)
    const [tagOpen, setTagOpen] = useState(false)
    const [openComment, setOpenComment] = useState(false)
    const [errmsg, setErrmsg] = useState("")
    const [suggest, setSuggest] = useState(null)
    const [tag, setTag] = useState("")

    const getData = () => {
        setErrmsg("")
        var url = urlC(board, idea.Idea, "")

        // console.log(form)
        var req = getOptions;
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                setSuggest(response)
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });

    }
    useEffect(() => {
        setErrmsg("")
        // console.log(idea)
        if (open && idea) {
            getData()
        }
    }, [open, idea])

    const onChanged = () => {
        onChange()
    }

    const myLike = async () => {
        let x = await onLike()
    }


    const RemoveComment = (c) => {
        setErrmsg("")
        // console.log(c)

        let verb = "comment/"
        if (c.Status !== "") {
            verb = "status/"
        }
        var url = urlC(board, idea.Idea, verb + c.Uuid)
        if (admin) {
            url += "/" + c.SubscriberUuid
        } else {
            url += "/" + empty_uuid
        }

        // console.log(form)
        var req = deleteOptions;
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                getData()
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    }

    const RemoveIdea = () => {
        setErrmsg("")

        var url = urlC(board, idea.Idea, "")
        var req = deleteOptions;
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                onChange()
                onClose()
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    }


    return (
        <>
            {open && (
                <>
                    <Dialog
                        sx={{
                            overflow: "scroll",
                            "& .MuiDialog-container": {
                                display: "inline-flex !important",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                overflow: "scroll",
                                px: 20,
                                py: 20,
                                mx: 30,
                            },
                        }}

                        minwidth="800"
                        maxWidth="100%"
                        open={open}
                        onClose={onClose}
                    // disableEscapeKeyDown={true}
                    >
                        <Stack sx={{ mx: 4, mt: 4 }} spacing={4}>
                            <Box
                                sx={{
                                    bgcolor: "#eff3e5",
                                    minWidth: 500,
                                    border: "1px solid grey",
                                    mx: 10,
                                }} >
                                {suggest !== null && (
                                    <Stack sx={{ mx: 4, mt: 2 }} spacing={4}>
                                        <Stack direction="row" spacing={2}>
                                            <Box>
                                                <Chip sx={{ mt: 1.5 }}
                                                    label={form.Status}
                                                    variant="contained"
                                                    color={colorStatus(suggest.Idea.Status)}
                                                    size="small"
                                                />
                                            </Box>
                                            <Typography variant="h6" gutterBottom>
                                                {suggest.Idea.Title}
                                            </Typography>
                                            <Box

                                                sx={{
                                                    display: "flex",
                                                    flexGrow: 1,
                                                    alignContent: "center",
                                                    justifyContent: "flex-end",
                                                }}
                                            >
                                                <CloseIcon
                                                    onClick={onClose}
                                                />
                                            </Box>
                                        </Stack>
                                        <Paper background-color="#eff3e5" elevation={2} sx={{
                                            backgroundColor: "#eff3e5",
                                        }}>
                                            < Typography variant="body2" sx={{ my: 2, mx: 20 }} gutterBottom>

                                                <span
                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(replaceWithBr(suggest.Idea.Comment)) }}
                                                />
                                            </Typography>
                                        </Paper>
                                        <Stack direction="row" spacing={2}>
                                            <IconCount
                                                tooltip={admin ? "Add Tag" : ""}
                                                count={suggest.Idea.Tags.length}
                                                icon={faTag}
                                                onClick={() => setTagOpen(admin)}
                                                color="#7fc3e5"
                                            />
                                            <Box >
                                                <Stack direction="row" sx={{ mt: -0.5 }} spacing={2}>
                                                    {suggest.Idea.Tags && suggest.Idea.Tags.length > 0 &&
                                                        suggest.Idea.Tags.map((t, i) => (
                                                            <Tag
                                                                key={"tag:" + t + i}
                                                                tagcolor={t}
                                                                onClick={() => { setTag(t); setTagOpen(admin) }}
                                                            />
                                                        ))}
                                                </Stack>
                                            </Box>
                                            <AddTag open={tagOpen} board={board} idea={form} tag={tag} avail={avail.Tags}
                                                onClose={() => { setTag(""); setTagOpen(false) }}
                                                onTagged={onChanged} />

                                        </Stack>

                                        <Stack direction="row" spacing={2}>
                                            <Stack direction="row" sx={{ pt: 0.5 }} spacing={2}>
                                                {(admin || (suggest.Idea.Mine && StatusMap(suggest.Idea.Status).deletable && suggest.Idea.Votes === 0 && suggest.Idea.CommentCount === 0)) && (
                                                    <FontAwesomeIcon
                                                        icon={faScissors}
                                                        color='black'
                                                        size="sm"
                                                        onClick={RemoveIdea}
                                                    />
                                                )}
                                                {(admin || suggest.Idea.Mine) && (
                                                    <>
                                                        <FontAwesomeIcon
                                                            icon={faEdit}
                                                            color='blue'
                                                            size="sm"
                                                            onClick={() => setNewOpen(true)}
                                                        />
                                                        <SuggestionNew board={board} name={name}
                                                            open={newOpen} onClose={() => { setNewOpen(false); onChanged() }}
                                                            ideaId={suggest.Idea.Idea}
                                                            title={suggest.Idea.Title}
                                                            comment={suggest.Idea.Comment}
                                                        />
                                                    </>
                                                )}
                                            </Stack>
                                            <Typography variant="body2" fontWeight="bold" sx={{ ml: 5, pt: 0 }} gutterBottom>
                                                {suggest.Idea.Author + "   "}
                                            </Typography>
                                            <Typography variant="body2" sx={{ ml: 5, pt: 0 }} gutterBottom>
                                                {dayjs(form.Date).format("D-MMM-YYYY H:mm")}
                                            </Typography>
                                            <IconCount
                                                tooltip="Like"
                                                count={suggest.Idea.Votes}
                                                icon={suggest.Idea.Voted ? faThumbsUpSolid : faThumbsUp}
                                                color="#7fc3e5"
                                                onClick={myLike}
                                            />
                                            <IconCount
                                                tooltip="Add Comment"
                                                count={suggest.Idea.CommentCount}
                                                icon={suggest.Idea.CommentCount ? (suggest.Idea.Commented ? faCommentDotsSolid : faCommentDots) :
                                                    (suggest.Idea.Commented ? faCommentSolid : faComment)}
                                                onClick={() => setOpenComment(true)}
                                                color="#7fc3e5"
                                            />
                                        </Stack>
                                    </Stack>
                                )}
                            </Box>
                        </Stack >
                        <DialogContent>
                            <Stack sx={{ mx: 4, mt: 2 }} spacing={4}>
                                <Timeline position="right"
                                    sx={{
                                        [`& .${timelineOppositeContentClasses.root}`]: {
                                            flex: 0.2,
                                        },
                                    }}>
                                    {suggest !== null && suggest.Comments &&
                                        suggest.Comments.map((c, i) => (
                                            <TimelineComment
                                                key={"tlc:" + i}
                                                board={board}
                                                idea={idea}
                                                c={c}
                                                onRemove={() => RemoveComment(c)}
                                                onChange={onChanged}
                                            />
                                        ))}
                                </Timeline>
                            </Stack>
                        </DialogContent>
                        <ErrorBar error={errmsg} />
                    </Dialog >
                    <AddComment open={openComment} board={board} idea={form}
                        onClose={() => setOpenComment(false)}
                        onCommented={onChanged} />
                </>
            )
            }
        </>
    )
}

const IconCount = ({ icon, count, color, tooltip, onClick = () => { } }) => {
    return (
        <Box  >
            <Stack sx={{ ml: 2, mt: 0.5 }} direction="row" spacing={1.5}>
                <Tooltip
                    title={tooltip}
                    enterDelay={1000}
                >
                    <FontAwesomeIcon
                        icon={icon}
                        color={color}
                        size="sm"
                        onClick={onClick}
                    />
                </Tooltip>
                <Box>
                    <Stack sx={{ mt: -0.25 }}>
                        <Typography variant="caption" color={iconColor} align="left" width={30} gutterBottom>
                            {count}
                        </Typography>
                    </Stack>
                </Box>

            </Stack>
        </Box>
    )
}

// name must === the state name for the go service, can't add spaces etc ... unless we trim them 
// anyway needs to correspond, so leave 'Not Validated' as 'NotValidated'  means the badge will also show that ..unless have a displayName
const statusMap_ = {
    NotValidated: {
        name: "NotValidated",
        color: "grey",
        colorhex: "#e2e200",
        icon: faLightbulb,
        deletable: true,
    },
    Suggested: {
        name: "Suggested",
        color: "ideayellow",
        colorhex: "#e2e200",
        icon: faLightbulbSolid,
        deletable: true,
    },
    Planned: {
        name: "Planned",
        color: "purpledark",
        colorhex: "#ce93d8",
        icon: faThumbsUp,
    },
    InProgress: {
        name: "InProgress",
        color: "primary",
        colorhex: "#7fc3e5",
        icon: faSpinner,
    },
    Completed: {
        name: "Completed",
        color: "helpgreen",
        colorhex: "#17be34",
        icon: faCheck,
    },
    Rejected: {
        name: "Rejected",
        color: "softred",
        colorhex: "#C41E3A",
        icon: faBan,
    },
    Trashed: {
        name: "Trashed",
        color: "grey",
        colorhex: "#222222",
        icon: faTrashAlt,
        deletable: true,
    },
    New: {
        name: "New",
        color: "helpgreen",
        colorhex: "#17be34",
        icon: faBullhorn,
    },
    Recent: {
        name: "Recent",
        color: "primary",
        colorhex: "#7fc3e5",
        icon: faBullhorn,
    },
    Old: {
        name: "Old",
        color: "grey",
        colorhex: "#C41E3A",
        icon: faScroll,
    },
}


const colorStatus = (status) => {
    let s = StatusMap(status)
    return s.color

}

const colorStatusHex = (status) => {
    let s = StatusMap(status)
    return s.colorhex

}

const StatusMap = (status) => {
    let s = statusMap_[status]
    if (s === undefined || s === null) {
        return statusMap_["Trashed"]
    }
    return s
}

const ShortComment = (c) => {
    return c.slice(0, 80) + (c.length > 80 ? " ..." : "")
}

const ShortTitle = (c, n) => {
    return c.slice(0, n) + (c.length > n ? " ..." : "")
}




const StatusIcons = ({ statuses, onClick }) => {
    return (
        <Stack sx={{ ml: 2, mt: 2 }} direction="row" spacing={2}>
            {statuses && statuses.filter(i => i !== "All").map((s, i) => {
                let sm = StatusMap(s);
                return (
                    <React.Fragment
                        key={"rf:" + i}>
                        {sm !== null && (
                            <Tooltip
                                title={sm.name}
                                enterDelay={1000}>

                                <FontAwesomeIcon
                                    icon={sm.icon}
                                    color={sm.colorhex}
                                    size="sm"
                                    onClick={() => onClick(sm.name)}
                                />
                            </Tooltip >
                        )}
                    </React.Fragment>
                )
            })
            }

        </Stack >
    )

}

const Tag = ({ tagcolor, onClick = null }) => {
    const { palette } = createTheme();
    const { augmentColor } = palette;
    const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });



    const tagSplit = (tc) => {
        let spl = tc.split(":")
        let regExp = /^#[0-9A-F]{6}$/i
        if (spl.length === 2) {
            if (regExp.test(spl[1])) {
                return spl
            } else {
                return [spl[0], "#dddddd"]
            }
        } else if (spl.length === 1) {
            return [spl[0], "#dddddd"]
        }
        return ["", "#dddddd"]
    }

    const [tag, color] = tagSplit(tagcolor)

    const theme = createTheme({
        palette: {
            special: createColor(color)

        }
    })



    return (
        <ThemeProvider theme={theme}>
            <Chip
                label={tag}
                variant="contained"
                color="special"
                size="small"
                onClick={onClick}
            />
        </ThemeProvider>
    )
}


const SuggestionLine = ({ name, board, idea, status, statuses, form, uuid, comment, onComment, onChange, avail }) => {
    const { admin_r } = useAuth();
    const [admin] = useState(admin_r.current)

    const [openComment, setOpenComment] = useState(false)
    const [openSuggestion, setOpenSuggestion] = useState(false)
    const [errmsg, setErrmsg] = useState("")


    const Like = () => {
        setErrmsg("")
        if (!idea.Voted) {
            let nf = {
                ...form,
                "Vote": "Up",
            };
            var url = urlC(board, idea.Idea, "vote")
            // console.log(nf)
            var req = postOptions;
            req.body = JSON.stringify(nf);
            ftchPlus(url, req)
                .then((response) => {
                    // console.log(response);
                    onChange()
                })
                .catch((error) => {
                    // console.log(error);
                    setErrmsg(error.message)
                });
        }
    }

    const StatusChange = (status) => {
        setErrmsg("")
        let nf = {
            ...form,
            "Status": status,
        };
        //setForm(nf);

        var url = urlC(board, idea.Idea, "status")
        // console.log(nf)
        var req = postOptions;
        req.body = JSON.stringify(nf);
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                onChange()
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    }

    useEffect(() => {
        setErrmsg("")
    }, [])

    const Comment = () => {
        onComment(uuid)
        //setOpenComment(comment === uuid)
    }
    const closeComment = () => {
        onComment(-1)
    }

    const onSuggestion = () => {
        setOpenSuggestion(true)
    }

    return (
        <Box sx={{ width: "300", maxWidth: "400", bgcolor: "#eff3e5", ml: -200 }}>
            <Stack direction="row" spacing={4}>
                <Box  >
                    {admin && (
                        <>
                            <StatusIcons
                                statuses={statuses}
                                onClick={StatusChange}
                            />
                        </>
                    )}
                </Box>
                <Box>
                    <Stack direction="row" sx={{ mt: 1.0 }} spacing={2}>
                        <Typography variant="body2" sx={{ minWidth: 150, maxWidth: 150, overflow: "hidden" }} gutterBottom>
                            {form.Author}
                        </Typography>
                        <Typography variant="body2" sx={{ minWidth: 125, maxWidth: 125 }} gutterBottom>
                            {dayjs(form.Date).format("D-MMM-YYYY H:mm")}
                        </Typography>
                        <Typography variant="body2" sx={{ minWidth: 125, maxWidth: 125 }} gutterBottom>
                            {dayjs(form.Modified).format("D-MMM-YYYY H:mm")}
                        </Typography>
                    </Stack>
                </Box>
                <Box sx={{ width: "130", minWidth: 130, maxWidth: 130, overflow: "hidden" }}>
                    <Stack direction="row" sx={{ mt: 0.5 }} spacing={2}>
                        {form.Tags && form.Tags.length > 0 &&
                            form.Tags.map((t, i) => (
                                <Tag
                                    key={"tag:" + t + i}
                                    tagcolor={t}
                                />
                            ))}
                    </Stack>
                </Box>

                <Box>
                    <Stack direction="row" sx={{ mt: 1.0 }} spacing={2}>
                        <IconCount
                            tooltip="Like"
                            icon={form.Voted ? faThumbsUpSolid : faThumbsUp}
                            count={form.Votes}
                            onClick={Like}
                            color="#7fc3e5"

                        />
                        <IconCount
                            tooltip="Add Comment"
                            count={form.CommentCount}
                            icon={form.CommentCount ? faCommentDots : faComment}
                            onClick={Comment}
                            color="#7fc3e5"

                        />
                    </Stack>
                </Box>
                {status === "All" && (
                    <Box sx={{ minWidth: 100 }}>
                        <Stack sx={{ mt: 0.5 }}>
                            <Chip
                                label={form.Status}
                                variant="contained"
                                color={colorStatus(form.Status)}
                                size="small"
                            />
                        </Stack>
                    </Box>
                )}
                <Button
                    variant="text"
                    size="small"
                    color="black"
                    onClick={onSuggestion}
                    sx={{
                        width: 400,
                        maxWidth: 400,
                        // mt: -4,
                        justifyContent: "flex-start",
                        textTransform: 'none'
                    }}>
                    {ShortTitle(form.Title, 55)}

                </Button>
                <Tooltip
                    title={form.Comment}
                    placement="bottom-start"
                >
                    <Button
                        variant="text"
                        size="small"
                        color="black"
                        onClick={onSuggestion}
                        sx={{
                            width: 600,
                            maxWidth: 600,
                            // mt: -4,
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            // alignContent: "flex-end",
                            textTransform: 'none'
                        }}>
                        {/* <span
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(replaceWithBr(form.Comment)) }}
                    /> */}
                        {ShortComment(form.Comment)}
                    </Button>
                </Tooltip>
                <AddComment open={comment === uuid} board={board} idea={form} status={status} onClose={closeComment} onCommented={onChange} />

            </Stack >
            <Suggestion name={name} open={openSuggestion} board={board} idea={idea} form={form} onClose={() => setOpenSuggestion(false)} onLike={Like} onChange={onChange} avail={avail} />
            <ErrorBar error={errmsg} />
        </Box>
    )
}


const SuggestionList = ({ name, board, lists, status, statuses, onChange, avail }) => {
    const { admin_r } = useAuth();
    const [admin] = useState(admin_r.current)
    const [comment, setComment] = useState(-1)

    const List = () => {
        // console.log(status)
        // console.log(lists)
        if (lists[status]) {
            // console.log(lists[status])
            // console.log(lists[status].length)
        }

        if (lists && lists[status] && lists[status].length > 0) {
            return lists[status]
        }
        return []

    }

    return (
        <Box
            sx={{
                display: "flex",
                flexGrow: 1,
                justifyContent: "flex-start",
                alignContent: "center",
                maxWidth: "100%",
                minWidth: "500",
                maxHeight: "100%",
                minHeight: "100%",
                bgcolor: "#eeeeee"
            }}>
            <Stack sx={{ mx: 20 }} spacing={2}>
                <Box
                    bgcolor="#eff3e5"
                >
                    <Stack direction="row" sx={{ mt: 1.0 }} spacing={2}>
                        {admin && (
                            <Typography variant="body2" sx={{ minWidth: 21 * statuses.length, maxWidth: 21 * statuses.length }} gutterBottom>
                                Progression
                            </Typography>
                        )}
                        <Typography variant="body2" sx={{ minWidth: 150, maxWidth: 150 }} gutterBottom>
                            Author
                        </Typography>
                        <Typography variant="body2" sx={{ minWidth: 125, maxWidth: 125 }} gutterBottom>
                            Date
                        </Typography>
                        <Typography variant="body2" sx={{ minWidth: 125, maxWidth: 125 }} gutterBottom>
                            Modified
                        </Typography>
                        <Typography variant="body2" sx={{ minWidth: 130, maxWidth: 130 }} gutterBottom>
                            Labels
                        </Typography>
                        <Typography variant="body2" sx={{ minWidth: 150, maxWidth: 150 }} gutterBottom />

                        {status === "All" && (
                            <Typography variant="body2" sx={{ pl: 2, minWidth: 90, maxWidth: 90 }} gutterBottom>
                                Status
                            </Typography>
                        )}
                        <Typography variant="body2" sx={{ pl: 5, minWidth: 400, maxWidth: 400, display: "flex", justifyContent: "flex-start", }} gutterBottom>
                            Title
                        </Typography>
                        <Typography variant="body2" sx={{ pl: 7, minWidth: 400, maxWidth: 400, display: "flex", justifyContent: "flex-start", }} gutterBottom>
                            Detail
                        </Typography>

                    </Stack>
                </Box>
                {List(board).map((s, i) => (
                    <SuggestionLine
                        key={"sug:" + s.Idea}
                        name={name}
                        board={board}
                        idea={s}
                        form={s}
                        uuid={i}
                        status={status}
                        statuses={statuses}
                        comment={comment}
                        onComment={(uuid) => setComment(uuid)}
                        onChange={onChange}
                        avail={avail}
                    />
                ))}
            </Stack>
        </Box >
    )
}



const SuggestionBoard = ({ title, name, board, sort_ = "Votes", extraNewText = "" }) => {
    const { admin_r } = useAuth();
    const [admin] = useState(admin_r.current)

    const [status, setStatus] = useState("")
    const [sort, setSort] = useState(sort_)
    const [newOpen, setNewOpen] = useState(false)
    const [newIdea, setNewIdea] = useState({})
    const [errmsg, setErrmsg] = useState("")
    const [data, setData] = useState({})
    const [search, setSearch] = useState(null)
    const [sortData, setSortData] = useState(null)
    const [latest, setLatest] = useState("")

    const StatusList = () => {
        let s = []

        if (data && data.Avail) {
            if (admin) {
                if (data.Avail.Statuses_admin) {
                    s.push(...data.Avail.Statuses_admin)
                }
            } else {
                if (data.Avail.Statuses) {
                    s.push(...data.Avail.Statuses)
                }
            }
        }
        // console.log(s)

        return s
    }

    const getLists = () => {
        let l = latest
        if (l === "Sort") {
            if (sortData !== null) {
                // console.log("Sorted")
                // console.log(sortData)
                return sortData
            }
            l = "Search"
        }
        if (l === "Search") {
            if (search !== null) {
                // console.log("Seached")
                // console.log(search)
                if (l !== latest) {
                    setLatest(l)
                }
                return search
            }
            l = ""
        }
        if (l !== latest) {
            setLatest(l)
        }
        if (data && data.Ideas) {
            return data.Ideas
        }
        return {}
    }

    const ChangeStatus = (newStatus) => {
        setStatus(newStatus)
    }

    const OpenNew = () => {
        let n = structuredClone(defIdea)
        setNewIdea(n)
        setNewOpen(true)
        // console.log(n)
    }


    const getData = () => {
        setErrmsg("")
        var url = urlL(board)
        var req = getOptions;
        // console.log(url)
        ftchPlus(url, req)
            .then((response) => {
                // console.log(response);
                response.Avail.Statuses.push("All")
                response.Avail.Statuses_admin.push("All")
                let all = []
                for (let st in response.Ideas) {
                    all.push(...response.Ideas[st])
                }
                response.Ideas["All"] = all
                setData(response)
                DoSort(response.Ideas, sort)
                // console.log(response)

                if (status === "") {
                    setStatus(response.Avail.Statuses[0])
                }
            })
            .catch((error) => {
                // console.log(error);
                setErrmsg(error.message)
            });
    }

    const Update = () => {
        // console.log("update")
        getData()
    }

    useEffect(() => {
        getData()
    }, [])

    // future
    const SortBy = (e) => {
        // console.log(e)
        let sort = e.target.value
        setSort(sort)
        Sort(sort, search)
    }

    const Sort = (sort, n_search) => {
        let raw = data.Ideas
        if (n_search !== null) {
            raw = n_search
        }
        DoSort(raw, sort)
    }

    const DoSort = (raw, sort, n_search) => {
        let sortdata = {}
        if (sort === "Votes") {
            for (let st in raw) {
                sortdata[st] = raw[st].toSorted((a, b) => ((a.Votes < b.Votes) ? 1 : ((a.Votes === b.Votes) ? dayjs(b.Date) - dayjs(a.Date) : -1)))
            }
            setSortData(sortdata)
        } else if (sort === "Comments") {
            for (let st in raw) {
                sortdata[st] = raw[st].toSorted((a, b) => ((a.CommentCount < b.CommentCount) ? 1 : -1))
            }
            setSortData(sortdata)

        } else if (sort === "Date") {
            for (let st in raw) {
                sortdata[st] = raw[st].toSorted((a, b) => dayjs(b.Date) - dayjs(a.Date))
            }
            setSortData(sortdata)
        }
        else if (sort === "Modified") {
            for (let st in raw) {
                sortdata[st] = raw[st].toSorted((a, b) => dayjs(b.Modified) - dayjs(a.Modified))
            }
            setSortData(sortdata)
        }
        setLatest("Sort")

    }

    // future
    const onSearch = (term) => {
        // console.log("Search <" + term + ">")
        let ts = {}
        let raw = data.Ideas
        if (sortData !== null) {
            // console.log("Use sorted Data")
            raw = sortData
        }
        for (let st in raw) {
            // search[s] = data.Ideas[s].filter(s => s.Title.includes(term) || s.Comment.includes(term) || s.Tags.filter(t => t.includes(term)))
            ts[st] = raw[st].filter(s => s.Title.includes(term) || s.Comment.includes(term) || s.Tags.filter(t => t.includes(term)).length !== 0)
        }
        setSearch(ts)
        setLatest("Search")
    }
    const clearSearch = () => {
        setSearch(null)
        if (sortData) {
            Sort(sort, null)
        }

    }

    return (
        <>
            <Stack spacing={2}>
                <Stack direction="row" spacing={4}>
                    <Typography variant="h5" align="left" gutterBottom>
                        {title}
                    </Typography>
                    <ToggleSet current={status} set={StatusList()} onChange={ChangeStatus} />

                    <InputSelect1
                        label="Sort by"
                        onChange={SortBy}
                        value={sort}
                        minWidth={140}
                        maxWidth={140}
                        avail={["Votes", "Date", "Modified", "Comments"]}
                    />
                    <InputSearch
                        onSearch={onSearch}
                        onClear={clearSearch}
                    />
                    <>
                        {(name !== "News" || (name === "News" && admin)) && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexGrow: 1,
                                    justifyContent: "flex-end",
                                }}
                            >
                                <Button variant="contained" onClick={OpenNew}>
                                    {"New " + name}
                                </Button>
                            </Box>
                        )}
                    </>
                </Stack>
                <SuggestionList
                    name={name}
                    board={board}
                    lists={getLists()}
                    status={status}
                    statuses={StatusList()}
                    onChange={Update}
                    avail={data.Avail}
                />
            </Stack>
            <SuggestionNew board={board} name={name} open={newOpen} onClose={() => { setNewOpen(false) }}
                extraText={extraNewText} />

            <Help_suggestionBoard />
            <ErrorBar error={errmsg} />

        </>
    )
}

export default SuggestionBoard;